<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-1">
              <v-expand-transition>
              <v-card-text>
                <v-form ref="authForm" >
                  <v-text-field
                    type="password"
                    ref="code"
                    :disabled="isLoading"
                    outlined
                    v-model="code"
                    validate-on-blur
                    label="Code"
                    required
                    :rules="[
                      (v) =>
                        !!v || $t('form.validationErrors.field_is_required'),
                    ]"
                    append-icon="fa-key"
                    id="code"
                    hide-details
                    name="code"
                    @keydown.enter.stop="login"
                  ></v-text-field>
                  <v-divider class="mt-5"></v-divider>
                </v-form>
              </v-card-text>
              </v-expand-transition>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  elevation="0"
                  class="mb-2 mr-2"
                  min-width="100"
                  color="success"
                  @click="login"
                  @keydown.enter.stop="login"
                >
                  {{ $t("form.login.login") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import LanguageSwitcher from "../components/common/LanguageSwitcher";
import RegisterForm from "@/components/RegisterForm";
import {f} from "vuetify-dialog-promise";
export default {
  name: "Auth",
  components: {RegisterForm, LanguageSwitcher },
  data: () => ({
    isVisibleRegisterForm: false,
    checkbox: false,
    code: null
  }),
  computed: {
    ...mapFields("auth", ["isLoading", "authenticated"]),
  },
  methods: {
    login() {
      if (!this.$refs.authForm.validate() || !this.code) return;
      this.$store.dispatch("auth/login_as", {
        code: this.code,
        client_id: this.$route.params.client_id
      }).then(() => {
        if (this.authenticated) {
          this.$router.push({ name: "Sites" });
        }
      });
      return false;
    },
    showRegisterForm(){

    }
  },
};
</script>
